import React, { ReactElement } from 'react';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import { useMap } from 'react-leaflet';
import { MapControl, TooltipIconButton } from '..';
import { useTranslation } from 'react-i18next';

export function MapFullscreenControl(): ReactElement {
	const map = useMap();
	const { t } = useTranslation('general');

	function toggleFullscreen(): void {
		(map as any).toggleFullscreen();
	}

	return (
		<MapControl>
			<TooltipIconButton
				onClick={toggleFullscreen}
				placement="left"
				tooltip={t('zoomButtons.fullScreen')}
				icon={<FullscreenIcon />}
			/>
		</MapControl>
	);
}
